module.exports = __webpack_public_path__ + "static/media/human-advantage-headset.2d15b91d.svg";